import React, { useEffect } from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { Main, Container } from '../../components';
import Button from '@mui/material/Button';

import intro from '../../assets/images/study.jpg';
import working from '../../assets/images/working.png';

import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LanguageIcon from '@mui/icons-material/Language';
import { styled } from '@mui/system';
import { alpha } from '@mui/material/styles';

const CustomButton = styled(Button)(({theme})=>({
  color: theme.palette.text.secondary,
  transition: 'all 0.6s',
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.dark, 0.2),
    color: theme.palette.secondary.main,
  },
}));

const AboutPage = () =>{
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  useEffect(() => {
    document.title = 'Course Pool | About';
  }, []);
  return(
  <Main>
    <Box 
    position={'relative'} 
    sx={{backgroundColor: theme.palette.alternate.main,}}
    >
      <Container>
        <Box
          bgcolor={'alternate.main'}
          padding={{ xs: 2, md: 4 }}
          borderRadius={2}
        >
          <Box 
            marginBottom={2}
            textAlign={{sm:'center', md: 'left'}}
          >
            <Typography
              variant="h3"
              component={'h3'}
              sx={{
                fontWeight: 700,
              }}
            >
              Course Pool
            </Typography>
          </Box>
          <Grid container spacing={4}>
            <Grid
              item
              container
              xs={12}
              md={6}
              alignItems={'center'}
              sx={{ position: 'relative' }}
              data-aos={isMd ? 'fade-right' : 'fade-up'}
            >
              <Box marginBottom={1}>
                
                <Box>
                  <Typography variant="h6" component="p" color="text.secondary">
                  Nowadays, people can learn anything from anywhere with the help of Internet. Some courses are fee-required, some are free.
                  </Typography>
                  <Typography variant="h6" component="p" color="text.secondary">
                  Unfortunately, a great number of people just don't think the free courses are worth it or don't know those courses exists.
                  </Typography>
                  <Typography variant="h6" component="p" color="text.secondary">
                  Course Pool is a web application built to help solve this problem. It provides free tutorials with the best quality to extend programming knowledge.
                  </Typography>
                  <Typography variant="h6" component="p" color="text.secondary">
                  All tutorials are organized in the library with tags for easy-to-find desired skills.
                  </Typography>
                </Box>              
              </Box>
              
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                height={1}
                width={1}
                display={'flex'}
                justifyContent={'center'}
              >
                <Box
                  height={1}
                  width={1}
                  maxWidth={{ xs: 600, md: '100%' }}
                  maxHeight={500}
                >
                  <Box
                    component={'img'}
                    src={intro}
                    width={1}
                    height={1}
                    sx={{
                      objectFit: 'cover',
                      filter:
                        theme.palette.mode === 'dark'
                          ? 'brightness(0.8)'
                          : 'none',
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
          
        </Box>
      </Container>
      <Container>
        <Box
          bgcolor={'alternate.main'}
          paddingX={{ xs: 2, md: 4 }}
          borderRadius={2}
        >
          <Box 
            textAlign={{sm:'center', md: 'right'}}
          >
            <Typography
              variant="h3"
              component={'h3'}
              sx={{
                fontWeight: 700,
              }}
            >
              About Me
            </Typography>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box
                height={1}
                width={1}
                display={'flex'}
                justifyContent={'center'}
              >
                <Box
                  height={1}
                  width={1}
                  maxWidth={{ xs: 600, md: '100%' }}
                  maxHeight={500}
                >
                  <Box
                    component={'img'}
                    src={working}
                    width={1}
                    height={1}
                    sx={{
                      objectFit: 'cover',
                      filter:
                        theme.palette.mode === 'dark'
                          ? 'brightness(0.8)'
                          : 'none',
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              container
              xs={12}
              md={6}
              alignItems={'center'}
              sx={{ position: 'relative' }}
              data-aos={isMd ? 'fade-right' : 'fade-up'}
            >
              <Box marginBottom={4}>
                
                <Box marginBottom={3}>
                  <Typography variant="h6" component="p" color="text.secondary">
                  My name is Hung Quoc Tran. I am a Software Engineer with a huge passion for building things and solving problems.
                  </Typography>

                    <Typography variant="h6" component="p" color="text.secondary">
                      Check out more about what I am working on 
                    </Typography>
                  <Box paddingTop={2}>
                    <Grid 
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center" 
                      spacing={4}
                      columns={{ xs: 4, sm: 8, md: 12 }}
                    >
                      <Grid item>
                        <Box  
                          component={"a"}
                          href={'#'}
                          target={"_blank"}
                        >
                          <CustomButton >
                            <GitHubIcon  fontSize='large'/>
                          </CustomButton>
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box  
                          component={"a"}
                          href={'#'}
                          target={"_blank"}
                        >
                          <CustomButton >
                            <LinkedInIcon fontSize='large'/>
                          </CustomButton>
                        </Box>
                        
                      </Grid>
                      <Grid item>
                        <Box  
                          component={"a"}
                          href={'#'}
                          target={"_blank"}
                        >
                          <CustomButton >
                            <LanguageIcon fontSize='large'/>
                          </CustomButton>
                        </Box>
                        
                      </Grid>                      
                    </Grid>
                  </Box>
                </Box>              
              </Box>
              
            </Grid>
          </Grid>
          
        </Box>
      </Container>
    </Box>

  </Main>
    )
}

export default AboutPage;
